export const AUTH_ENDPOINTS = {
  SIGNIN: '/account/signin',
  SIGNUP: '/account/signup',
  VERIFY: '/account/verify',
  CHECK_EMAIL: '/account/check-email',
} as const;
